import { UsedPriceStepText } from "./types";

export const USED_PRICE_BASIC_STEP = 0;
export const USED_PRICE_DETAILS_STEP = 1;
export const USED_PRICE_EQUIPMENT_STEP = 2;

/** Naslov i objašnjenje ispod scene, po koraku. */
export const USED_PRICE_INTRO_TEXTS: Record<number, UsedPriceStepText> = {
  [USED_PRICE_BASIC_STEP]: {
    title: "Izračunajte cijenu rabljenog vozila",
    description: "Odaberite vozilo iz kataloga. Cijena se računa prema podacima CVH za odabrani datum.",
  },
  [USED_PRICE_DETAILS_STEP]: {
    title: "Koliko je vozilo staro?",
    description: "Datum prve registracije i kilometraža najviše utječu na cijenu. Uz njih idu CO2 i snaga motora.",
  },
  [USED_PRICE_EQUIPMENT_STEP]: {
    title: "Dodajte opremu vozila",
    description: "Označite dodatnu opremu koju vozilo ima. Ona podiže cijenu, pa je izračun točniji.",
  },
};

/** Primjeri dok korisnik ništa nije upisao. */
export const USED_PRICE_INTRO_SAMPLE = {
  jom: "JOM 104 223",
  mileageKm: 84500,
  firstRegistrationYear: 2021,
  co2: 128,
  enginePower: 110,
  equipment: [
    { name: "Navigacijski sustav", price: 850 },
    { name: "Grijanje sjedala", price: 420 },
    { name: "Parkirni senzori", price: 380 },
  ],
  estimatedPrice: 18900,
};
